export default Object.freeze({
  ProcessApprovalEvaluation: 0,
  Delegation: 1,
  DelegationRestored: 2,
});
